import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover as HeadlessUIPopover, Transition } from '@headlessui/react';
import { Fragment, memo, PropsWithChildren } from 'react';

import { buttonBaseClasses, buttonColorVariants } from '@/constants/buttonStyles';
import { Color } from '@/constants/color';
import { Props } from '@/ui/components/Popover/types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const Popover = ({
  buttonClass = '',
  buttonColor,
  buttonRound = false,
  buttonSize = 'base',
  closeButton = true,
  children,
  popoverButtonText
}: PropsWithChildren<Props>) => {
  const borderRadius = buttonRound ? 'rounded-full' : 'rounded-sm';
  const padding = buttonSize === 'xs' ? 'px-2 py-1' : 'px-4 py-2';

  return (
    <HeadlessUIPopover className="relative">
      {({ open }) => (
        <>
          <HeadlessUIPopover.Button
            className={`
                ${open ? '' : 'text-opacity-90'}
                ${buttonBaseClasses} ${
                  buttonColorVariants[buttonColor]
                } text-${buttonSize} ${borderRadius} ${padding} ${buttonClass}`}>
            <span>{popoverButtonText}</span>
          </HeadlessUIPopover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1">
            <HeadlessUIPopover.Panel className="absolute z-10 mt-2 w-max transform sm:px-0 lg:max-w-3xl opacity-100 translate-y-0">
              {({ close }) => (
                <div className="rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                  {closeButton && (
                    <div className="rounded-t-md bg-gray-100 h-5 border border-b border-t-0 border-x-0 border-solid border-gray-200">
                      <div className="absolute right-1 top-0.5">
                        <button
                          aria-label="Close popover"
                          className="flex justify-center items-center shadow-sm  h-4 w-4 border px-1 py-0.5 text-gray-50 bg-gray-500 rounded-full focus:ring-2 focus:ring-offset-2"
                          color={Color.GRAY}
                          onClick={() => close()}
                          type="button">
                          <FontAwesomeIcon icon={faTimes} size="xs" />
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="relative p-3">{children}</div>
                </div>
              )}
            </HeadlessUIPopover.Panel>
          </Transition>
        </>
      )}
    </HeadlessUIPopover>
  );
};

export default memo(Popover);
